import "./tweenmax.js";

// Hiệu ứng quay dùng lại cách của ttl3d/2025-sonquy-2: TweenMax kéo một biến
// góc, mỗi tick ghi lại transform cho vòng 8 ô. Quay 3 vòng rồi dừng đúng ô.
class DnDRotate {
  constructor(el) {
    this.el = el;
    this.temp = -1;
    this.angleObj = { angle: 0 };
  }

  loop() {
    this.drawRotated(this.angleObj.angle);
    if (this.angleObj.angle === this.temp) {
      TweenLite.ticker.removeEventListener("tick", this.bound);
      if (typeof this.onDone === "function") this.onDone();
    }
    this.temp = this.angleObj.angle;
  }

  drawRotated(degrees) {
    this.el.style.setProperty("--f2-angle", degrees + "deg");
  }

  animateRotate(targetAngle, duration, onDone) {
    this.onDone = onDone;
    this.bound = this.loop.bind(this);
    TweenMax.to(this.angleObj, duration, { angle: targetAngle, delay: 0, repeat: 0 });
    setTimeout(() => {
      TweenLite.ticker.addEventListener("tick", this.bound);
    }, 0);
  }
}

// Frame2 - vòng quay: chọn phe, hiệu ứng quay, cập nhật thanh tiến độ.
window.addEventListener("load", function () {
  const frame = document.querySelector("#frame2");
  if (!frame) return;

  // ---- thẻ tướng / chọn phe: để cứng trong HTML ---------------------------
  // Landing KHÔNG xử lý gì ở khu này nữa (không đổi ảnh thẻ theo phe, không bật
  // tắt is-active / is-picked): phe và thẻ nào sáng là do HTML render sẵn,
  // backend tự đổi khi có dữ liệu người chơi.
  const factions = frame.querySelectorAll(".f2-faction");
  const slotEls = frame.querySelectorAll(".f2-slot");

  // Tra ảnh avatar vòng quay theo slug tướng — gom từ data của cả 4 nút phe nên
  // phủ đủ 16 tướng, và path đã được ImageOptimizePlugin rewrite sẵn.
  // Dùng getAttribute: "data-hero-1" KHÔNG đổi thành dataset.hero1 vì dấu gạch
  // đứng trước chữ số thì không được camelCase.
  const wheelSrcBySlug = {};
  factions.forEach(function (f) {
    const slugs = (f.getAttribute("data-wheel-slugs") || "").split("|");
    slugs.forEach(function (slug, k) {
      const src = f.getAttribute("data-hero-" + (k + 1));
      if (slug && src) wheelSrcBySlug[slug] = src;
    });
  });

  // Đổi 8 ô vòng quay sang một tướng. Dùng cho kết quả quay, và mở ra
  // window.f2ShowWheelOf('<slug>', '<tên tướng>') để backend gọi khi cần.
  const showWheelOf = (slug, name) => {
    const src = wheelSrcBySlug[slug];
    if (!src) return;
    slotEls.forEach(function (slot) {
      slot.setAttribute("data-hero", slug);
      const img = slot.querySelector(".f2-slot-hero");
      img.src = src;
      img.alt = name || "";
    });
  };

  window.f2ShowWheelOf = showWheelOf;

  // ---- tab mốc cấp độ / mốc cấp nạp ---------------------------------------
  // Mỗi tab là một bảng .f2-board riêng trong HTML (bảng không hiện để
  // display:none), landing không đổi tab — backend tự bật/tắt.

  // ---- quay vòng ----------------------------------------------------------
  const wheelEl = frame.querySelector(".f2-wheel");
  const readAttr = (name) => (wheelEl && wheelEl.getAttribute(name)) || "";
  const SLOT_COUNT = Number(readAttr("data-prize-slots")) || 8;

  // Bảng tra mã quà: chữ cái -> tướng (ảnh 8 ô), do config.js quy định.
  const prizeCodes = readAttr("data-prize-codes").split("");
  const prizeSlugs = readAttr("data-prize-slugs").split("|");
  const prizeNames = readAttr("data-prize-names").split("|");
  const heroByLetter = {};
  prizeCodes.forEach(function (letter, i) {
    heroByLetter[letter] = { slug: prizeSlugs[i], name: prizeNames[i] };
  });
  // Quay 2s cho đỡ phải chờ. Khi nối libraryMainsite.promotion nhớ set
  // config.timeWait = 2000 cho khớp, nếu không popup quà sẽ bật lệch nhịp.
  const SPIN_SECONDS = 2;
  const ring = frame.querySelector(".f2-wheel-ring");
  const spinButtons = frame.querySelectorAll(".f2-spin");
  let running = false;

  // Tách mã quà "A1".."P8" thành { letter, slot }. Mã lạ (sai định dạng, chữ
  // cái ngoài bảng) thì lùi về ô 1 để vòng quay vẫn chạy thay vì đứng hình.
  const parsePrizeCode = (code) => {
    const text = String(code || "").toUpperCase();
    const letter = text.charAt(0);
    const slot = parseInt(text.slice(1), 10);
    if (!heroByLetter[letter] || !(slot >= 1 && slot <= SLOT_COUNT)) {
      console.warn("frame2: mã quà không đọc được:", code);
      return { letter: letter, slot: 1 };
    }
    return { letter: letter, slot: slot };
  };

  // Quay về ô thứ indexImg (1..8), giống AnimationLucky của sonquy-2.
  // Ô sáng cuối cùng phải là ô đang nằm ngay mũi kim (đỉnh vòng quay).
  // Theo thứ tự layer PSD, ô đỉnh là ô cuối (index 7); quay thêm indexImg*45°
  // theo chiều kim đồng hồ thì ô rơi vào đỉnh là (indexImg - 1) mod 8.
  const animationLucky = (indexImg, countItems) => {
    if (!ring || running) return;
    running = true;
    slotEls.forEach(function (s) { s.classList.remove("is-active"); });
    const target = Math.floor(indexImg * (360 / countItems)) + 360 * 3;
    new DnDRotate(ring).animateRotate(target, SPIN_SECONDS, function () {
      running = false;
      const landed = slotEls[(indexImg - 1 + countItems) % countItems];
      if (landed) landed.classList.add("is-active");
    });
  };

  // Backend gọi lại được: window.f2AnimationLucky(indexImg, 8) trong animResult.
  window.f2AnimationLucky = animationLucky;

  // ---- kết quả quay: 1 lượt -> popup nhỏ, 10 lượt -> popup lưới ------------
  // libraryMainsite chỉ biết #popup_reward: quay bao nhiêu lượt nó cũng đổ hết
  // vào #rewardContainer rồi bật popup nhỏ, nên 10 quà xếp dọc tràn khung.
  // Mình điền sẵn lưới 5x2 của #popup_getlist rồi đổi popup ngay lúc thư viện
  // bật popup nhỏ. Đồng thời ghi đè src ảnh: mã lạ thì thư viện ghép ra
  // "undefined.png" (ảnh vỡ), còn mình quy về mã chuẩn <chữ cái><ô>.
  const rewardPopup = document.querySelector("#popup_reward");
  const rewardBox = document.querySelector("#rewardContainer");
  const listPopup = document.querySelector("#popup_getlist");
  const listItems = listPopup ? listPopup.querySelectorAll(".reward-item") : [];
  let multiPrize = false;

  // Ghép đường dẫn ảnh quà giống hệt thư viện: directory + items[mã] + type.
  const prizeSrc = (code) =>
    prodTemplate.directory + "/" + prodTemplate.items[code] + "." + prodTemplate.items.type;
  const prizeName = (code) => {
    const table = prodTemplate.names[document.body.className];
    return (table && table[code]) || "";
  };
  // Mã server có thể lệch định dạng; quy về "<chữ cái><số ô>" đã kiểm tra được.
  const normalizePrizeCode = (raw) => {
    const parsed = parsePrizeCode(raw);
    return parsed.letter + parsed.slot;
  };

  // Dòng dưới ảnh quà = tên quà lấy từ prodTemplate.names; quay 10 ra nhiều
  // tướng thì ghép lại, tướng trùng chỉ kể một lần.
  const prizeNameLine = (codes) => {
    const names = [];
    codes.forEach(function (code) {
      const name = prizeName(code);
      if (name && names.indexOf(name) === -1) names.push(name);
    });
    return names.join(", ");
  };

  const fillRewardPopups = (codes) => {
    const popup = codes.length === 1 ? rewardPopup : listPopup;
    const total = popup && popup.querySelector(".pm__reward-total");
    if (total) total.textContent = prizeNameLine(codes);

    if (codes.length === 1 && rewardBox) {
      const img = rewardBox.querySelector("img");
      if (img) {
        img.src = prizeSrc(codes[0]);
        img.alt = prizeName(codes[0]);
      }
      return;
    }
    listItems.forEach(function (item, i) {
      const code = codes[i];
      item.style.display = code ? "" : "none";
      if (!code) return;
      const img = item.querySelector(".reward-hero");
      img.src = prizeSrc(code);
      img.alt = prizeName(code);
    });
  };

  // Thư viện bật popup nhỏ sau timeWait; bắt đúng lúc đó để đổi sang popup lưới.
  if (rewardPopup && listPopup) {
    new MutationObserver(function () {
      if (!multiPrize || !rewardPopup.classList.contains("active")) return;
      multiPrize = false;
      rewardPopup.classList.remove("active");
      listPopup.classList.add("active");
    }).observe(rewardPopup, { attributes: true, attributeFilter: ["class"] });
  }

  // ---- nối libraryMainsite.promotion ---------------------------------------
  // Cách khởi tạo lấy theo ttl3d/2025-sonquy-2: thư viện tự bắt click .pm__rut,
  // gọi API rút quà rồi trả về listPrize trong animResult; mình chỉ việc quay
  // vòng tới ô tương ứng. timeWait phải bằng thời gian quay, nếu không popup
  // quà bật lệch nhịp hiệu ứng.
  const promotion = window.libraryMainsite && window.libraryMainsite.promotion;
  const hasConfig = typeof prodTemplate !== "undefined";

  if (typeof promotion === "function" && hasConfig) {
    promotion({
      url: prodTemplate.url,
      debug: prodTemplate.debug,
      directory: prodTemplate.directory,
      items: prodTemplate.items,
      names: prodTemplate.names,
      textNotEnough: prodTemplate.textNotEnough,
      wordNumber: prodTemplate.wordNumber,
      config: {
        timeWait: SPIN_SECONDS * 1000
      },
      animResult: function (listPrize) {
        const prizes = listPrize || [];
        // Mã quà = <chữ cái tướng><số ô>, vd "A1".."P8": chữ cái quyết định ảnh
        // 8 ô (vòng quay của tướng đó), số quyết định ô dừng. Đổi ảnh TRƯỚC khi
        // quay để ô sáng lúc dừng đúng bằng ảnh popup quà bật ra sau đó.
        const parsed = parsePrizeCode((prizes[0] || {}).indexWord);
        const hero = heroByLetter[parsed.letter];
        if (hero) showWheelOf(hero.slug, hero.name);
        animationLucky(parsed.slot, SLOT_COUNT);

        // Quay 10 lượt: vòng quay chạy theo quà đầu, popup thì hiện đủ cả list.
        const codes = prizes.map(function (p) { return normalizePrizeCode(p.indexWord); });
        multiPrize = codes.length > 1;
        if (codes.length) fillRewardPopups(codes);
      },
      callback: function () {
        if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
      }
    });

    // Thư viện đã bind .pm__rut, chỉ cần chặn nhảy hash của thẻ <a href="#">.
    spinButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
      });
    });
  } else {
    // Chưa có thư viện (xem bản build tĩnh): quay ngẫu nhiên cho thấy hiệu ứng.
    spinButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        // Giả lập mã quà ngẫu nhiên "A1".."P8" để xem đúng luồng đổi ảnh + quay.
        const letter = prizeCodes[Math.floor(Math.random() * prizeCodes.length)];
        const parsed = parsePrizeCode(letter + (Math.floor(Math.random() * SLOT_COUNT) + 1));
        const hero = heroByLetter[parsed.letter];
        if (hero) showWheelOf(hero.slug, hero.name);
        animationLucky(parsed.slot, SLOT_COUNT);
      });
    });
  }

  // ---- tooltip mốc nạp ----------------------------------------------------
  // Chuyển tooltip sang .MS__outer để nổi trên bảng tải game (#float-right).
  // Quy đổi toạ độ bằng chính #float-right (đã biết vị trí px thiết kế) nên
  // không phụ thuộc transform-origin mà libraryMainsite đặt cho lớp này.
  const outer = document.querySelector(".MS__outer");
  const floatPanel = document.querySelector("#float-right");
  const rows = frame.querySelectorAll(".f2-board-row");

  if (outer && floatPanel && rows.length) {
    const FLOAT_LEFT = 1789;
    const FLOAT_TOP = 358;
    const FLOAT_W = 203;

    rows.forEach(function (row) {
      const tip = row.querySelector(".f2-board-tip");
      if (!tip) return;
      outer.appendChild(tip);

      row.addEventListener("mouseenter", function () {
        const fr = floatPanel.getBoundingClientRect();
        if (!fr.width) return;
        const scale = fr.width / FLOAT_W;
        const originX = fr.left - FLOAT_LEFT * scale;
        const originY = fr.top - FLOAT_TOP * scale;
        const rr = row.getBoundingClientRect();
        // Giữ đúng lệch của PSD: tooltip nằm phải hàng 184px, cao hơn 50px.
        tip.style.left = (rr.left - originX) / scale + 184 + "px";
        tip.style.top = (rr.top - originY) / scale - 50 + "px";
        tip.style.display = "block";
      });

      row.addEventListener("mouseleave", function () {
        tip.style.display = "";
      });
    });
  }

  // ---- thanh tiến độ ------------------------------------------------------
  const progress = frame.querySelector(".f2-progress");
  if (progress) {
    const current = Number(progress.getAttribute("aria-valuenow") || 0);
    const max = Number(progress.getAttribute("aria-valuemax") || 100);
    progress.style.setProperty("--f2-progress", (current / max) * 100 + "%");
  }
});
